import * as React from 'react';
const BreakpointsContext = React.createContext([1200, 992, 768, 540]);
export const useBreakpoints = () => React.useContext(BreakpointsContext);
export function BreakpointsProvider({ children, breakpoints }) {
    return React.createElement(BreakpointsContext.Provider, { value: breakpoints }, children);
}
